import { render } from "./receiveGiftCard.vue?vue&type=template&id=7ff06988&scoped=true"
import script from "./receiveGiftCard.vue?vue&type=script&lang=js"
export * from "./receiveGiftCard.vue?vue&type=script&lang=js"

import "./receiveGiftCard.vue?vue&type=style&index=0&id=7ff06988&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff06988"]])

export default __exports__